import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }
const _hoisted_2 = { class: "from-item" }

import Vue, {
  onMounted,
  ref,
  watch,
  defineAsyncComponent,
  onBeforeUnmount,
  computed,
} from "vue";
import { orderSubCancelList, orderSubCancel } from "@/api/api";
import { notification } from "ant-design-vue";
import { onBeforeRouteLeave } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'Subscription',
  props: {
    appData: {},
    isRefresh: { type: Boolean },
    dbName: {}
  },
  setup(__props: any) {

const XATable = defineAsyncComponent(() => import("../components/XATable.vue"));
const store = useStore();

const props = __props;
const rightAppIdVal = ref<any[]>([]);
var appIdList: any[] = [];
const maxTagCount = ref(1);
const checkedValue = ref(true);

const columns = ref([
  {
    title: "包名",
    key: "packageName",
    dataIndex: "packageName",
  },
  {
    title: "运营ID",
    key: "operatorName",
    dataIndex: "operatorName",
  },
  {
    title: "用户ID",
    key: "userId",
    dataIndex: "userId",
  },
  {
    title: "用户名",
    key: "userName",
    dataIndex: "userName",
  },
  {
    title: "订单类型",
    key: "type",
    dataIndex: "type",
    slots: {
      customRender: "type",
    },
  },
  {
    title: "订单编号",
    key: "tradeNo",
    dataIndex: "tradeNo",
  },
  {
    title: "地区",
    key: "ipName",
    dataIndex: "ipName",
  },
  {
    title: "订阅价格",
    key: "amount",
    dataIndex: "amount",
    slots: {
      customRender: "amount",
    },
  },
  {
    title: "订阅次数",
    key: "subPayTotal",
    dataIndex: "subPayTotal",
  },
  {
    title: "订阅天数",
    key: "subDayTotal",
    dataIndex: "subDayTotal",
  },
  {
    title: "总充值",
    key: "userAmountTotal",
    dataIndex: "userAmountTotal",
    slots: {
      customRender: "userAmountTotal",
    },
  },
  {
    title: "充值次数",
    key: "userPayTotal",
    dataIndex: "userPayTotal",
  },
  {
    title: "下单时间",
    key: "orderTime",
    dataIndex: "orderTime",
    isAllTime: true,
  },
  {
    title: "取消时间",
    key: "cancelTime",
    dataIndex: "cancelTime",
    isAllTime: true,
  },
]);
const tableData = ref([]);
const loading = ref(false);
let timerInval = ref();
var subOrderIds: any[] = [];

const getRequestData = () => {
  loading.value = true;
  orderSubCancelList({
    dbName: `${decodeURIComponent(rightAppIdVal.value.join(","))}`,
  }).then((res) => {
    loading.value = false;
    if (res.data.length) {
      tableData.value = res.data;
    }
  });
};

const startSubTimer = () => {
  clearInterval(timerInval.value);
  timerInval.value = null;
  timerInval.value = setInterval(() => {
    suborderSubCancel();
  }, 2000);
};
// 监听 Vuex 的 refreshNeeded 状态
const refreshNeeded = computed(() => store.state.refreshNeeded);

// 监控 refreshNeeded 的变化
watch(refreshNeeded, (newValue) => {
  if (newValue) {
    // 执行页面刷新操作
    getRequestData();
    // 重置刷新状态
    store.dispatch("resetRefresh");
  }
});

watch(
  () => props.isRefresh,
  (cur, old) => {
    if (rightAppIdVal.value.length) {
      getRequestData();
      // startSubTimer();
    }
  }
);

watch(
  () => store.state.configList,
  (cur, old) => {
    rightAppIdVal.value = cur;
  },
  { immediate: true }
);
// watch(
//   () => props.appData,
//   (cur, old) => {
//     if (cur) {
//       appIdList = [];
//       cur.forEach((val: { dbName: any }) => {
//         appIdList.push(val.dbName);
//       });
//       if (localStorage.getItem("SUBAPPIDLIST")) {
//         rightAppIdVal.value = JSON.parse(
//           localStorage.getItem("SUBAPPIDLIST") as string
//         );
//       } else {
//         rightAppIdVal.value = appIdList;
//       }
//       if (rightAppIdVal.value.length) {
//         getRequestData();
//         startSubTimer();
//       }
//     }
//   },
//   { immediate: true, deep: true }
// );

// const suborderSubCancel = () => {
//   orderSubCancel({
//     dbName: `${decodeURIComponent(rightAppIdVal.value.join(","))}`,
//   }).then((res) => {
//     if (res.data && res.data.length) {
//       let data = res.data[0];
//       subOrderIds = JSON.parse(localStorage.getItem("SubOrderIds") as string)
//         ? JSON.parse(localStorage.getItem("SubOrderIds") as string)
//         : [];
//       if (!subOrderIds.includes(data.tradeNo)) {
//         //弹出窗口
//         if (checkedValue.value) {
//           notification["warning"]({
//             message: "取消订阅通知",
//             description: `${data.packageName}-${data.userName} 用户取消订阅`,
//           });
//         }
//         getRequestData();
//         subOrderIds.push(data.tradeNo);
//         localStorage.setItem("SubOrderIds", JSON.stringify(subOrderIds));
//       }
//     }
//   });
// };

const notifChange = (val: boolean) => {
  store.state.dispatch("changeSubCheckedValue");
};

const rightAppIdValChange = (val: any[]) => {
  store.dispatch("changeSubConfigList", val);
  if (val.length) {
    getRequestData();
  }
};
onMounted(() => {
  // let val = localStorage.getItem("NotifNO");
  // if (val) {
  //   checkedValue.value = val === "true" ? true : false;
  // }
  checkedValue.value = store.state.subCheckedValue;
  getRequestData();
});
onBeforeUnmount(() => {
  // clearInterval(timerInval.value);
  // timerInval.value = null;
});

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_select, {
        ref: "select",
        value: rightAppIdVal.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rightAppIdVal).value = $event)),
        mode: "multiple",
        onChange: rightAppIdValChange,
        "max-tag-count": maxTagCount.value,
        style: {"min-width":"120px","margin-bottom":"10px"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appData, (item) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: item.dbName,
              value: item.dbName
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.packageName), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value", "max-tag-count"]),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 弹窗提醒 "),
        _createVNode(_component_a_switch, {
          style: {"margin-left":"10px"},
          checked: checkedValue.value,
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((checkedValue).value = $event)),
          onChange: notifChange
        }, null, 8, ["checked"])
      ])
    ]),
    _createVNode(_unref(XATable), {
      columns: columns.value,
      dataSource: tableData.value,
      scroll: { x: 1500 },
      loading: loading.value
    }, {
      type: _withCtx(({ scope }) => [
        _createTextVNode(_toDisplayString(scope.record.type === 1
          ? "充值"
          : scope.record.type === 2
          ? "VIP"
          : scope.record.type === 3
          ? "SVIP"
          : ""), 1)
      ]),
      userAmountTotal: _withCtx(({ scope }) => [
        _createTextVNode(_toDisplayString("$" + (scope.record.userAmountTotal / 100).toFixed(2)), 1)
      ]),
      amount: _withCtx(({ scope }) => [
        _createTextVNode(_toDisplayString("$" + (scope.record.amount / 100).toFixed(2)), 1)
      ]),
      _: 1
    }, 8, ["columns", "dataSource", "loading"])
  ], 64))
}
}

})